import { useEffect, useRef, useState } from 'react'
import moment, { Moment } from 'moment'
import { useUnmount } from 'Src/hooks/useUnmount'

export const useTimer = (
	timeFrom: string | Moment,
	TIME_LIMIT: number,
	isReverseTime?: boolean
) => {
	const [timerSecond, setTimerSecond] = useState(0)
	const timer = useRef<NodeJS.Timeout>(null)

	const startTimer = (sec: number) => {
		clearTimeout(timer.current)
		const beginTimer = (seconds: number) => {
			if (seconds > 1) {
				setTimerSecond(seconds - 1)
				clearTimeout(timer.current)
				timer.current = setTimeout(beginTimer, 1000, seconds - 1)
			} else {
				setTimerSecond(0)
			}
		}
		timer.current = setTimeout(beginTimer, 0, sec)
	}

	useEffect(() => {
		if (timeFrom) {
			const reverseSecond = moment(timeFrom).diff(moment(), 'seconds')
			const second = moment().diff(moment(timeFrom), 'seconds')
			if (!isReverseTime && second <= TIME_LIMIT) {
				startTimer(TIME_LIMIT - second)
			} else if (isReverseTime && reverseSecond) {
				startTimer(reverseSecond)
			}
		}
	}, [timeFrom])

	useUnmount(() => {
		if (timer.current) clearTimeout(timer.current)
	})

	return {
		timerSecond,
		setTimerSecond,
	}
}
